import Vue from 'vue';
import $ from 'jquery';

Vue.directive('tooltip', {
    bind(el, binding) {
        $(el).attr('data-toggle', 'tooltip')
            .attr('title', binding.value)
            .attr('data-placement', binding.arg)
            .attr('trigger', 'hover')
            .tooltip({ container: 'body' });
    },
    componentUpdated(el, binding) {
        $(el).attr('data-original-title', binding.value == null ? '' : binding.value)
            .tooltip('fixTitle');
    },
    unbind(el) {
        $(el).tooltip('destroy');
    }
});



// WEBPACK FOOTER //
// ./FrontEnd/diretivas/tooltip.js